import React from "react";
import {
    ContactContainer,
    ContactContent,
    ContactEmail,
    ContactInfo,
    ContactSection,
    QuoteFromTeam,
    StyledFont,
    StyledInfo,
    StyledInfoWrapper,
} from "./Contact.styles";
import SectionTitle from "../../../components/section-items/SectionTitle/SectionTitle";
import SectionText from "../../../components/section-items/SectionText/SectionText";
import { MAIN_COLOR } from "../../../components/globalThemes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons/faEnvelope";
import SectionContainer from "../../../components/section-items/SectionContainer/SectionContainer";
import Logo from "../../../components/logos/Logo/Logo";
import { CONTACT_EMAIL, TEAM_NAME } from "../../../utils/info";

const Contact = () => {
    return (
        <ContactSection id={"contact"} portraitHeight={"700px"}>
            <StyledInfo>
                <StyledInfoWrapper>
                    <Logo width={150} height={150} style={{ opacity: 0.5 }} />
                    <QuoteFromTeam>
                        {`Dziękujemy za odwiedzenie naszej strony\n— Zarząd klubu ${TEAM_NAME} `}
                    </QuoteFromTeam>
                </StyledInfoWrapper>
            </StyledInfo>
            <ContactContainer>
                <ContactContent href={"mailto:" + CONTACT_EMAIL}>
                    <FontAwesomeIcon
                        icon={faEnvelope}
                        color={MAIN_COLOR}
                        style={{ width: 75, height: 75, marginBottom: 30 }}
                    />
                    <ContactEmail>
                        <StyledFont>{"ERNESTBIES"}</StyledFont>
                        {"@GMAIL.COM"}
                    </ContactEmail>
                </ContactContent>
            </ContactContainer>
            <ContactInfo>
                <SectionContainer type={"contact"}>
                    <SectionTitle color={"white"}>{"KONTAKT"}</SectionTitle>
                    <SectionText color={"white"}>
                        {
                            "Chcesz zostać naszym partnerem lub po prostu wesprzeć naszą drużynę? Zapraszamy do kontaktu na podany adres e-mail albo na oficjalnej stronie na Facebooku. Dzięki Waszej pomocy i wsparciu będziemy mogli się rozwijać i dalej odnosić sukcesy."
                        }
                    </SectionText>
                </SectionContainer>
            </ContactInfo>
        </ContactSection>
    );
};

export default Contact;
